// O gráfico do topo da área de trabalho sob a política de CRONOGRAMA do Sienge (a tela
// legada de ajustes de mês): a curva do cronograma de desembolso do ERP, mês a mês — o mesmo
// papel que `AmpliCurveChart` tem sob a política Ampli, na mesma moldura e com a mesma
// seleção de meses.
//
// A fonte é a série do cronograma que `getDetail` publica (`plannedCashFlowSeries
// .disbursement`, com `disbursements` como plano B). A tela legada não tem seletor de
// período: a série vem inteira, na ordem das competências.
//
// Quando a obra não tem curva para desenhar, nada é desenhado e o motivo é declarado; um
// cronograma incompleto (`needs_adjustment`) desenha o que há e avisa que está em ajuste.
import { useMemo } from "react";

import MonthlyBarChart from "./MonthlyBarChart";

const NO_SERIES_TEXT = "Nenhuma curva de desembolso para desenhar.";
const UNAVAILABLE_TEXT =
  "Esta obra ainda não tem cronograma de desembolso do ERP para desenhar.";
const NEEDS_ADJUSTMENT_TEXT =
  "O cronograma de desembolso está em ajuste: a cobertura do que o ERP distribuiu ainda é parcial.";

const sortKey = (date) => String(date).slice(3) + String(date).slice(0, 2);

const scheduleSeries = (project) => {
  const published =
    project?.plannedCashFlowSeries?.disbursement ?? project?.disbursements;
  return (Array.isArray(published) ? published : [])
    .filter((point) => /^(0[1-9]|1[0-2])\/\d{4}$/.test(String(point?.date)))
    .sort((left, right) => (sortKey(left.date) < sortKey(right.date) ? -1 : 1));
};

const ScheduleCurveChart = ({
  project,
  selectedMonths = null,
  onToggleMonth = null,
  onClearMonths = null,
}) => {
  const series = useMemo(() => scheduleSeries(project), [project]);
  const state = project?.cashFlowPlanning?.state ?? null;
  const unavailable = state === "unavailable" || state === "inconsistent";
  const hasSeries = series.length > 0 && !unavailable;

  const detail = unavailable
    ? UNAVAILABLE_TEXT
    : state === "needs_adjustment"
      ? NEEDS_ADJUSTMENT_TEXT
      : null;

  return (
    <section
      className={`ampli-curve-chart ampli-curve-chart--schedule ampli-curve-chart--${
        state ?? "unknown"
      }`}
    >
      <h2>Cronograma de desembolso</h2>
      {detail ? <p>{detail}</p> : null}
      {hasSeries ? (
        <MonthlyBarChart
          labels={series.map((point) => point.date)}
          datasets={[
            {
              label: "Cronograma de desembolso (R$)",
              data: series.map((point) => Number(point.value) || 0),
              backgroundColor: "#2563EB",
              selectable: true,
            },
          ]}
          ariaLabel="Gráfico do cronograma de desembolso mensal da obra"
          selectedMonths={selectedMonths}
          onToggleMonth={onToggleMonth}
          onClearMonths={onClearMonths}
        />
      ) : unavailable ? null : (
        <p className="empty-state">{NO_SERIES_TEXT}</p>
      )}
    </section>
  );
};

export default ScheduleCurveChart;
